import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router-dom';
import { oidcConfig } from './Common/Constants/Auth.OidcConfig';
import Pages from './Pages';
import { StoreProvider } from './Store/Store.context';
import '@jupiter/react-common-component/dist/global-styles/index.scss';
import './index.scss';

export const App = () => {
  return (
    <AuthProvider {...oidcConfig}>
      <StoreProvider>
        <BrowserRouter>
          <Pages />
        </BrowserRouter>
      </StoreProvider>
    </AuthProvider>
  );
};
const container = document.getElementById('app') as HTMLElement;
const root = createRoot(container);

export default root.render(<App />);
